import _ from "underscore";

export default function closestPlan(choicePlans, basePlan, sameCarrier) {
  let filterStartPlans = choicePlans;
  if (sameCarrier && _.filter(choicePlans, (plan) => plan.carrier == basePlan.carrier).length > 0) {
    filterStartPlans = _.filter(choicePlans, (plan) => plan.carrier == basePlan.carrier);
  }
  const planPrices = filterStartPlans.map((planCompare) => [planCompare.id, Math.abs(planCompare.total_employee_premium - basePlan.total_employee_premium)]);

  const closestPlan = _.min(planPrices, (price) => price[1]);
  return _.find(filterStartPlans, (choice) => choice.id == closestPlan[0]);
}
